import { DemographicDataPoint } from 'src/common-services/types/demo-types'
import { Day } from 'src/common-services/types/drive-time-types'
import { pointSchema } from 'src/common-services/types/util-types'
import z from 'zod'

export enum BuildoutDriveTimeTypes {
  ARRIVAL = 'inbound',
  DEPARTURE = 'outbound',
}

export const MAX_DRIVE_TIME_DURATION = 120
export const MAX_RADIUS_RINGS_RADIUS = 100

export type BuildoutDemographicsConfig = {
  categories: Record<keyof typeof DemographicDataPoint, boolean>
  driveTime: {
    day: Day
    type: BuildoutDriveTimeTypes
    visible: boolean
    durations: [number, number, number]
  }
  radiusRings: {
    visible: boolean
    radii: [number, number, number]
  }
}

export type BuildoutTheme = {
  primaryColor: string
  // secondaryColor: string
}

export type BuildoutConfig = {
  configId: string
  buildoutId: string
  position: GeoJSON.Point
  allowConfigure: boolean
  config: BuildoutDemographicsConfig
  theme: BuildoutTheme
}

export type BuildoutVerifyTokenServiceResponse = {
  id: string
  point: GeoJSON.Point
  allowConfigure: boolean
  ttlSeconds: number
  theme: BuildoutTheme
}

export const buildoutConfigSchema = z.object({
  categories: z.object({
    Overview: z.boolean(),
    Households: z.boolean(),
    HousingUnits: z.boolean(),
    Gender: z.boolean(),
    Ethnicity: z.boolean(),
    Age: z.boolean(),
    MaritalStatus: z.boolean(),
    ValueOfOwnerOccupiedHousingUnits: z.boolean(),
    TypesOfHousingUnits: z.boolean(),
    HouseholdIncome: z.boolean(),
    Education: z.boolean(),
    LaborForce: z.boolean(),
    TransportationToWork: z.boolean(),
    TravelTimeToWork: z.boolean(),
    PopulationByIndustry: z.boolean(),
    PopulationByOccupation: z.boolean(),
  }),
  driveTime: z.object({
    day: z.number().min(0).max(6),
    type: z.nativeEnum(BuildoutDriveTimeTypes).optional().default(BuildoutDriveTimeTypes.ARRIVAL),
    visible: z.boolean(),
    durations: z.array(z.number().min(1).max(MAX_DRIVE_TIME_DURATION)).length(3),
  }),
  radiusRings: z.object({
    visible: z.boolean(),
    radii: z.array(z.number().gt(0).max(MAX_RADIUS_RINGS_RADIUS)).length(3),
  }),
})

export const buildoutVerifyTokenRequestSchema = z.object({
  token: z.string().nonempty(),
})
export type BuildoutVerifyTokenRequest = z.infer<typeof buildoutVerifyTokenRequestSchema>

export const buildoutVerifyTokenResponseSchema = z.object({
  configId: z.string().nonempty(),
  buildoutId: z.string().nonempty(),
  position: pointSchema,
  config: buildoutConfigSchema,
  theme: z.object({
    primaryColor: z.string(),
    secondaryColor: z.string(),
  }),
})
export type BuildoutVerifyTokenResponse = z.infer<typeof buildoutVerifyTokenResponseSchema>

export const updateBuildoutConfigRequestSchema = z.object({
  configId: z.string().nonempty(),
  config: buildoutConfigSchema,
})
export type UpdateBuildoutConfigRequest = z.infer<typeof updateBuildoutConfigRequestSchema>
